export default __webpack_public_path__ + "static/media/Productivity Analysis.c27aa36d.png";